<template>
  <require from="components/countries-roles-user-panel"></require>
  <require from="controls/bs-form-input"></require>
  <require from="controls/as-page-jumbo.html"></require>
  <require from="controls/as-form-skeleton"></require>
  <require from="controls/as-form-section.html"></require>
  <require from="controls/as-widget-stack"></require>
  <require from="framework/html_behaviors/af-highlight.html"></require>
  <require from="framework/html_behaviors/bs-tooltip"></require>

  <div class="admin-roles-screen">
    <as-page-jumbo icon="fas fa-user-tag fa-fw" heading="Countries Roles administration" intro="Manage user's countries roles.">
      <div slot="default">
        <as-form-widget>
          <div slot="default">
            <div class="form-row">
              <div class="col-lg-8 col-xl-6">
                <div class="form-row flex-nowrap">
                  <div class="col">
                    <bs-form-input type="text" label="User or Country" placeholder="Type to search" value.bind="filterText & debounce"></bs-form-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </as-form-widget>
      </div>
    </as-page-jumbo>
    <form class="container-fluid">
      <div if.bind="loaded">
        <div class="as-form-section" repeat.for="user of users" show.bind="user.isVisible" style="border-bottom: 1px solid #e9ecef">
          <div class="d-flex">
            <h5 style="cursor: pointer;" click.delegate="user.isExpanded = !user.isExpanded">
              <i class="fas fa-angle-right" show.bind="!user.isExpanded"></i>
              <i class="fas fa-angle-down" show.bind="user.isExpanded"></i>
              <span as-element="af-highlight" text.bind="user.user.fullName" highlight.bind="filterText">${user.user.fullName}</span>
            </h5>
            <div class="sc-buttons-container text-nowrap" style="text-align: right; margin-left: auto;">
              <a href="#/${homeRoute & oneTime}/admin/countriesRoles/transferUserRoles/${user.user.id}" class="btn btn-secondary" title="Transfer Countries Roles">
                <i class="fas fa-fast-forward"></i>
              </a>
            </div>
          </div>
          <div if.bind="user.isExpanded" class="ml-2 mb-2">
            <countries-roles-user-panel user-country-role-model.bind="user"></countries-roles-user-panel>
            <div class="form-row">
              <div class="col">
                <h6>Approver for</h6>
                <as-widget-stack kind="admin-country-selector" widget-buttons.bind="countryButtons" new-item-widget-visible.bind="user.isCountryApproveEditing" items.bind="user.countriesApproveWrapper" add-new-item.call="user.addNewCountryApprove(item)" remove-item.call="user.removeCountryApprove(item)" empty-item-template.bind="newEmptyCountryWrapper"></as-widget-stack>
              </div>
            </div>
            <div class="form-row">
              <div class="col">
                <h6>Contact for</h6>
                <as-widget-stack kind="admin-country-selector" widget-buttons.bind="countryButtons" new-item-widget-visible.bind="user.isCountryContactEditing" items.bind="user.countriesContactWrapper" add-new-item.call="user.addNewCountryContact(item)" remove-item.call="user.removeCountryContact(item)" empty-item-template.bind="newEmptyCountryWrapper"></as-widget-stack>
              </div>
            </div>
            <div class="form-row">
              <div class="col">
                <h6>Delegates</h6>
                <as-widget-stack kind="admin-user-selector" widget-buttons.bind="userButtons" new-item-widget-visible.bind="user.isApproverDelegateEditing" add-new-item.call="user.addNewApproverDelegate(item)" remove-item.call="user.removeApproverDelegate(item)" items.bind="user.approverDelegatesWrapper" empty-item-template.bind="newEmptySystemUserWrapper"></as-widget-stack>
              </div>
            </div>
            <div class="form-row">
              <div class="col">
                <h6>Delegate of</h6>
                <as-widget-stack kind="admin-user-selector" widget-buttons.bind="userButtons" new-item-widget-visible.bind="user.isDelegateApproverEditing" add-new-item.call="user.addNewDelegateApprover(item)" remove-item.call="user.removeDelegateApprover(item)" items.bind="user.delegateApproversWrapper" empty-item-template.bind="newEmptySystemUserWrapper"></as-widget-stack>
              </div>
            </div>
          </div>
        </div>
      </div>
      <as-form-skeleton else></as-form-skeleton>
    </form>
  </div>
</template>
